import { render } from "./productSwiper.vue?vue&type=template&id=796bb7a2"
import script from "./productSwiper.vue?vue&type=script&lang=js"
export * from "./productSwiper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__